import React, { useMemo } from 'react';
import { Image } from '@fuxi/eevee-ui';

const CDN_PREFIX = 'https://static.fuxi.netease.com';

interface BannerBgProps {
  className?: string;
  url?: string;
  height?: number;
}

const BannerBg: React.FC<BannerBgProps> = ({ className, url = `auth-header-banner.png`, height = 260 }) => {
  const bannerUrl = `${CDN_PREFIX}/fuxi-art-platform/theme-dark-light/banner/${url}?image_process=format,webp`;
  const placeholderUrl = `${CDN_PREFIX}/fuxi-art-platform/theme-dark-light/banner/${url}?image_process=resize,w_200/format,webp`;

  return (
    <Image
      preview={false}
      height={height}
      src={bannerUrl}
      className={className}
      style={{ objectFit: 'cover' }}
      placeholder={
        <Image
          preview={false}
          height={height}
          src={placeholderUrl}
          className={className}
          style={{ objectFit: 'cover', filter: 'blur(5px)' }}
        />
      }
    />
  );
};

export default BannerBg;
